import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Token for an Observable used for cancelling requests to Parse.
 * When the Observable emits a value the current open requests are cancelled
 */
export const CANCEL_REQUEST_OBSERVABLE = new InjectionToken<Observable<boolean>>('<Parse API module> Cancel request observable');
